import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import {
  getJournalCaisseByIdApi,
  Journal,
} from "../../../_App/Redux/Slices/journalCaisse/journalCaisseSlice";
import {
  selectCaisse,
  SelectedOrganisationId,
} from "../../../_App/Redux/Slices/Auth/authSlice";
import { Button, Modal } from "react-bootstrap";
import ReactToPrint from "react-to-print";

const TicketClotureJournal = ({ ShowModal, setShowModal, id }: any) => {
  const dispatch = useAppDispatch();
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const caisse = useAppSelector(selectCaisse);

  useEffect(() => {
    const fetch = async () => {
      if (currentOrganisation && id) {
        dispatch(getJournalCaisseByIdApi(id));
      }
    };
    fetch();
  }, [dispatch, ShowModal]);
  const journal = useAppSelector(Journal);
  const componentRef = useRef<HTMLDivElement>(null);

  const handlePrint = () => {
    // Access the hidden iframe and trigger its print method
    const printFrame = document.getElementById(
      "print-frame"
    ) as HTMLIFrameElement | null;
    if (printFrame) {
      printFrame.contentWindow?.print();
    }
  };

  return (
    <Modal
      show={ShowModal}
      onHide={() => setShowModal(false)}
      className="ticket-modal"
      style={{ display: "flex", justifyContent: "center" }}
      size="lg"
    >
      <div ref={componentRef}>
        <div className="container-ticket" id="print-content ">
          <div className="receipt_header">
            <h1>
              Ticket de Cloture Journal <span>{journal.societe?.nom}</span>
            </h1>
            <h2 style={{ margin: 0 }}>
              {journal?.organisation_id?.nom || ""}{" "}
              <span>{"Tel: " + (journal.societe?.tel || "")}</span>
            </h2>
          </div>

          <div className="receipt_body">
            <div className="ticket-items mt-0">
              <table
                style={{
                  whiteSpace: "normal",
                  borderBottom: "1px dashed #000",
                }}
              >
                <tbody>
                  <tr>
                    <td>
                      <strong>Journal</strong>
                    </td>
                    <td>{journal?.code_journal}</td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td>
                      <strong>Caisse</strong>
                    </td>
                    <td>{caisse?.libelle}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Caissier</strong>
                    </td>
                    <td>
                      {(journal?.user_id?.nom || "") +
                        " " +
                        (journal?.user_id?.prenom || "")}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Fond initial</strong>
                    </td>
                    <td>{journal.font_initial}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Fond final</strong>
                    </td>
                    <td>{journal.font_final}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <ReactToPrint
        trigger={() => (
          <Button
            variant="contained"
            color="primary"
            onClick={handlePrint}
            className="btn-info"
          >
            Print
          </Button>
        )}
        content={() => componentRef.current}
      />
      {/* Hidden iframe for printing */}
      <iframe
        id="print-frame"
        title="print-frame"
        style={{ display: "none" }}
        onLoad={() => handlePrint()}
      />
    </Modal>
  );
};

export default TicketClotureJournal;
